/* eslint-disable no-useless-computed-key */
import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 992,
      lg: 1260,
      xl: 1920,
    },
  },
  typography: {
    fontFamily: 'Roboto Condensed',
    button: {
      textTransform: 'none',
    },
  },
  palette: {
    primary: {
      main: '#00B5E2',
      lighter: '#00B4E0',
      grey: '#647483',
    },
    secondary: {
      main: '#d81f27',
    },
  },
});

export default theme;
